import * as Yup from "yup";

export const createEmailSchema = (t) => {
  return Yup.object().shape({
    email: Yup.string().email(t("newsletter_email_invalid")),
    termsAccepted: Yup.boolean()
      .oneOf([true], t("newsletter_terms_error"))
      .required(t("newsletter_terms_error")),
  });
};
